import { createSlice } from "@reduxjs/toolkit";
//import { VerifyEmailData } from "../models/models";

const initialState = {
  subscriptionURL: [],
  isLoading: false,
  error: false,
  hasData: false,
  accessToken: ""
  // status: false
};
const newsletterPreferenceSlice = createSlice({
  name: "verifymail",
  initialState,
  reducers: {
    verifyMailDataRequest: (state, action) => {
      state.isLoading = true;
    },
    getVerifyMailDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.subscriptionURL = action.payload;
    },
    getVerifyMailDataFailure: (state, action) => {
      state.error = action.payload.response.data;
      state.isLoading = false;
    }
  }
});
export const {
  verifyMailDataRequest,
  getVerifyMailDataSuccess,
  getVerifyMailDataFailure
} = newsletterPreferenceSlice.actions;
export default newsletterPreferenceSlice.reducer;